import UrlPattern from 'url-pattern';

const construct = url => new UrlPattern('(*)' + url);

export const BASE_URL = '/api';

export const LOGIN = construct('/login');
export const PASSWORD_RESET = construct('/password_reset');

export const USER = construct('/user');
export const USER_UPDATE = construct('/user/update');
export const USER_BILLING = construct('/user/billing_info');

export const DICTIONARIES = construct('/dictionaries');

export const PRODUCT_LIST = construct('/product-list');
export const PRODUCTS = construct('/products');
export const SHOWCASES = construct('/showcases(/:id)');

export const DISTRIBUTORS = construct('/distributors-filter');
export const CITIES = construct('/cities')

export const PROJECTS = construct('/user/projects');
export const APPLICATIONS = construct('/user/applications(/:project)');
export const FEEDBACK = construct('/user/feedback');

export const NOTIFICATIONS = construct('/user/notifications');
export const NOTIFICATIONS_MARK = construct('/user/notifications/mark_read');
export const MESSAGES = construct('/user/messages(/:application)');

export const ADD_CHECK = construct('/user/applications/add_check/(/:application)');

export const BONUSES = construct('/user/bonuses');

export const SMS = construct('/user/sms-code');

export const ALL_APPLICATIONS = construct('/user/applications');


// WEBPACK FOOTER //
// ./src/constants/urls.js